const _array: Uint32Array = new Uint32Array(1);
const _discreteValues: number = ((36) ** 4);
const _limit: number = ((2) ** 32) - 1;
let _counter: number = 0;

function getRandomValue(): number {
    return Math.abs(crypto.getRandomValues(_array)[0] / _limit);
}

function pad(num: string): string {
    let s = `0000${num}`;
    return s.substring(s.length - 4);
}

function randomBlock(): string {
    return pad(((getRandomValue() * _discreteValues) << 0).toString(36));
}

function safeCounter(): number {
    let c = _counter;
    c = c < _discreteValues ? c : 0;
    _counter = c + 1;
    return c;
}

export default function nextCuid(): string {
    return `c${Date.now().toString(36)}${pad(safeCounter().toString(36))}${randomBlock()}${randomBlock()}`;
}
